<template>
  <form class="form special-marks">
    <h2>Отличительные признаки</h2>

    <template v-if="hasSpecialMarks">
      <template v-if="store.application.without_exams?.length">
        <h3>Право поступления без вступительных испытаний</h3>

        <fieldset v-for="item in store.application.without_exams" :key="item.id" class="form form--fieldset">
          <div class="form__group">
            <div class="special-marks__field">
              <t-text-growing disabled :model-value="item.special_mark.name || 'Не указано'" label="Отличительный признак"/>
              <button
                v-if="item.special_mark.full_name"
                type="button"
                class="btn btn--outline-primary btn--squared special-marks__info-button"
                @click="openFullNameModal('Отличительный признак', item.special_mark.full_name)"
              >
                <img class="btn__icon" src="~images/info.svg" v-svg-inline/>
              </button>
            </div>
          </div>
          <div v-if="item.olympic" class="form__group">
            <t-text-growing disabled :model-value="item.olympic" label="Олимпиада"/>
          </div>
        </fieldset>
      </template>

      <template v-if="store.application.olympic_max_grades?.length">
        <hr>
        <h3>Учет результатов олимпиад</h3>

        <fieldset v-for="item in store.application.olympic_max_grades" :key="item.id" class="form form--fieldset">
          <div class="form__group">
            <t-text disabled :model-value="item.discipline || 'Не указано'" label="Дисциплина"/>
          </div>
          <div class="form__group">
            <t-text-growing disabled :model-value="item.olympic || 'Не указано'" label="Олимпиада"/>
          </div>
        </fieldset>
      </template>

      <template v-if="store.application.benefits?.length">
        <hr>
        <h3>Льготы</h3>

        <fieldset v-for="item in store.application.benefits" :key="item.id" class="form form--fieldset">
          <div class="form__group">
            <div class="special-marks__field">
              <t-text-growing disabled :model-value="item.special_mark.name || 'Не указано'" label="Отличительный признак"/>
              <button
                v-if="item.special_mark.full_name"
                type="button"
                class="btn btn--outline-primary btn--squared special-marks__info-button"
                aria-label="Показать полное наименование"
                @click="openFullNameModal('Отличительный признак', item.special_mark.full_name)"
              >
                <img class="btn__icon" src="~images/info.svg" v-svg-inline/>
              </button>
            </div>
          </div>
        </fieldset>
      </template>

      <template v-if="store.application.target_educations?.length">
        <hr>
        <h3>Целевое обучение</h3>

        <fieldset v-for="item in store.application.target_educations" :key="item.id" class="form form--fieldset">
          <div class="form__group">
            <div class="special-marks__field">
              <t-text-growing disabled :model-value="item.contragent.name || 'Не указано'" label="Направляющая организация"/>
              <button
                v-if="item.contragent.full_name"
                type="button"
                class="btn btn--outline-primary btn--squared special-marks__info-button"
                aria-label="Показать полное наименование"
                @click="openFullNameModal('Направляющая организация', item.contragent.full_name)"
              >
                <img class="btn__icon" src="~images/info.svg" v-svg-inline/>
              </button>
            </div>
          </div>
          <div v-if="item.offer_number" class="form__group">
            <t-text disabled :model-value="item.offer_number" label="Номер предложения"/>
          </div>
        </fieldset>
      </template>

      <template v-if="hasCompatriot">
        <hr>
        <h3>Статус соотечественника</h3>

        <fieldset class="form form--fieldset">
          <div class="form__group">
            <div class="special-marks__field">
              <t-text-growing disabled :model-value="store.application.compatriot.name || 'Не указано'" label="Наименование"/>
              <button
                v-if="store.application.compatriot.full_name"
                type="button"
                class="btn btn--outline-primary btn--squared special-marks__info-button"
                aria-label="Показать полное наименование"
                @click="openFullNameModal('Статус соотечественника', store.application.compatriot.full_name)"
              >
                <img class="btn__icon" src="~images/info.svg" v-svg-inline/>
              </button>
            </div>
          </div>
        </fieldset>
      </template>
    </template>

    <div v-else class="card card--info">
      <img class="card__icon icon icon--primary" src="~images/info.svg" v-svg-inline/>
      <p>Отличительные признаки не указаны</p>
    </div>

    <t-modal v-if="fullNameModal" @close="closeFullNameModal">
      <div class="modal-header">{{ fullNameModal.title }}</div>
      <div class="modal-body">
        <p class="special-marks__full-name">{{ fullNameModal.text }}</p>
      </div>
      <div class="modal-footer">
        <button class="btn btn--primary" type="button" @click="closeFullNameModal">Закрыть</button>
      </div>
    </t-modal>
  </form>
</template>

<script setup>
import { ref, computed } from 'vue'
import { TText, TTextGrowing, TModal } from '@shared/ui'
import { useApplicationStore } from '@widgets/application-profile'

const store = useApplicationStore()
const fullNameModal = ref(null)

const openFullNameModal = (title, text) => {
  fullNameModal.value = { title, text }
}

const closeFullNameModal = () => {
  fullNameModal.value = null
}

const hasCompatriot = computed(() =>
  store.application.compatriot && Object.keys(store.application.compatriot).length > 0
)

const hasSpecialMarks = computed(() =>
  store.application.without_exams?.length ||
  store.application.olympic_max_grades?.length ||
  store.application.benefits?.length ||
  store.application.target_educations?.length ||
  hasCompatriot.value
)
</script>
